export default "__VITE_ASSET__Bnzpr$xV__"